export default __webpack_public_path__ + "static/media/S (25).10716fa0.png";